import React from "react";

export default function EmptyState({type}) {
  const activeMessage = "You don't have any Loan Plans yet. Please submit Purchase Orders or Invoices to get started with your Loan Application!";
  const repaidMessage = "You don't have any Repaid Loan Plans.";
  let message = type === 'active loans' ? activeMessage : repaidMessage;

  return(
    <div className="emptyState _paddingTop--xxxxlarge">
      <i className="materialIcon --large">move_to_inbox</i>
      <p className="byline">{message}</p> 
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/loans/components/EmptyState.js